import { render, staticRenderFns } from "./robotyy.vue?vue&type=template&id=2b0d7dc6&scoped=true&"
import script from "./robotyy.vue?vue&type=script&lang=js&"
export * from "./robotyy.vue?vue&type=script&lang=js&"
import style0 from "./robotyy.vue?vue&type=style&index=0&id=2b0d7dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d7dc6",
  null
  
)

export default component.exports